export const categories = [
  {
    id: 'dongzuo',
    name: '动作片',
    slug: 'dongzuo',
    icon: 'ri-sword-line',
    description: '紧张刺激的动作场面，热血沸腾的视觉盛宴',
    count: 128,
  },
  {
    id: 'juqing',
    name: '剧情片',
    slug: 'juqing',
    icon: 'ri-film-line',
    description: '深刻动人的故事叙述，引发共鸣的情感之旅',
    count: 256,
  },
  {
    id: 'jilupian',
    name: '纪录片',
    slug: 'jilupian',
    icon: 'ri-camera-line',
    description: '真实记录社会百态，探索未知世界的窗口',
    count: 89,
  },
  {
    id: 'xiju',
    name: '喜剧片',
    slug: 'xiju',
    icon: 'ri-emotion-laugh-line',
    description: '轻松幽默的欢乐时光，释放压力的最佳选择',
    count: 156,
  },
  {
    id: 'xuanyi',
    name: '悬疑片',
    slug: 'xuanyi',
    icon: 'ri-search-eye-line',
    description: '扣人心弦的谜题设计，烧脑刺激的推理体验',
    count: 94,
  },
  {
    id: 'kehuan',
    name: '科幻片',
    slug: 'kehuan',
    icon: 'ri-rocket-line',
    description: '天马行空的未来想象，震撼视效的科技之旅',
    count: 72,
  },
  {
    id: 'aiqing',
    name: '爱情片',
    slug: 'aiqing',
    icon: 'ri-heart-line',
    description: '浪漫唯美的情感故事，触动心弦的爱情篇章',
    count: 183,
  },
  {
    id: 'kongbu',
    name: '恐怖片',
    slug: 'kongbu',
    icon: 'ri-ghost-line',
    description: '惊悚刺激的恐怖体验，挑战胆量的极限之旅',
    count: 65,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};